import SavedFilter from "@mapmycustomers/shared/types/viewModel/SavedFilter";

const getSavedFilterName = (
  savedFilters: SavedFilter[] | undefined,
  savedFilterId: SavedFilter["id"] | undefined
): string | undefined => savedFilters?.find(({ id }) => id === savedFilterId)?.name;

export default getSavedFilterName;
